import { configureStore } from "@reduxjs/toolkit"
import appReducerSlice from "../redux/reducer/appReducer"

const store = configureStore({
  reducer: {
    app: appReducerSlice,
  },
})

export default store
